import Button from 'components/Button';
import styles from './ButtonWithIcon.module.scss';
import Typography from 'components/Typography';

interface ButtonWithIconProps {
  Icon: any;
  onClick: VoidFunction;
  label: string;
  disabled?: boolean;
}

const ButtonWithIcon = ({
  Icon,
  onClick,
  label,
  disabled,
}: ButtonWithIconProps) => {
  return (
    <div className={styles.buttonContainer}>
      <Button onClick={onClick} type="Background" disabled={disabled}>
        <Icon width={20} height={20} />
        {label && (
          <Typography type="label" weight="regular">
            {label}
          </Typography>
        )}
      </Button>
    </div>
  );
};

export default ButtonWithIcon;
